class CartTimer extends HTMLElement {
    constructor() {
        super();
        
        this.currentInterval = null;
        this.initTimer();
    }
    
    // Get DOM elements when needed (not in constructor)
    getTimerElements() {
        return {
            timerContainer: document.querySelector('.CartDrawer__Timer-Timer'),
            m1: document.getElementById('m1'),
            m2: document.getElementById('m2'),
            s1: document.getElementById('s1'),
            s2: document.getElementById('s2')
        };
    }
    
    getWithExpiry(key) {
        const itemStr = localStorage.getItem(key);
        if (!itemStr) {
            return null;
        }
        const item = JSON.parse(itemStr);
        const now = new Date();
        if (now.getTime() > item.expiry) {
            localStorage.removeItem(key);
            return null;
        }
        return item.value;
    }
    
    setWithExpiry(key, value) {
        const now = new Date();
        const ttl = 60 * 60 * 24; // 24 hours in seconds
        
        const item = {
            value: value,
            expiry: now.getTime() + ttl,
        };
        localStorage.setItem(key, JSON.stringify(item));
    }
    
    setCountdown(seconds) {
        const elements = this.getTimerElements();
        
        // Check if all elements exist
        if (!elements.m1 || !elements.m2 || !elements.s1 || !elements.s2) {
            console.warn('Timer display elements not found');
            return;
        }
        
        const minutes = Math.floor(seconds / 60).toString().padStart(2, '0');
        const secs = (seconds % 60).toString().padStart(2, '0');
        
        elements.m1.textContent = minutes[0];
        elements.m2.textContent = minutes[1];
        elements.s1.textContent = secs[0];
        elements.s2.textContent = secs[1];
    }
    
    showTimer() {
        const elements = this.getTimerElements();
        if (elements.timerContainer) {
            elements.timerContainer.style.display = 'block';
            // Also remove any hide classes if they exist
            elements.timerContainer.classList.remove('hideAlert', 'hidden');
        }
    }
    
    hideTimer() {
        const elements = this.getTimerElements();
        if (elements.timerContainer) {
            elements.timerContainer.style.display = 'none';
        }
    }

    startTimer(duration) {
        let timer = duration;

        this.showTimer();
        this.setCountdown(timer);

        this.currentInterval = setInterval(() => {
            timer--; // Decrement timer first

            if (timer < 0) {
                this.hideTimer();
                clearInterval(this.currentInterval);
                this.currentInterval = null;
                this.setWithExpiry('cartTimer', 0);
                return;
            }

            this.setCountdown(timer); // Then update the countdown display
            this.setWithExpiry('cartTimer', timer);
        }, 1000);
    }
    
    initTimer() {
        const currentValue = parseInt(this.getWithExpiry('cartTimer'));
        
        if (!this.currentInterval && currentValue > 0) {
            this.setCountdown(currentValue);
            this.startTimer(currentValue);
            this.showTimer();
        }
        
        if (currentValue === 0) {
            this.hideTimer();
        }
    }
    
    productAddedToCart() {
        console.log("---------------------------- productAddedToCart");
        const tenMinutes = 60 * 10;
        
        if (this.currentInterval) {
            clearInterval(this.currentInterval);
            this.currentInterval = null;
        }
        
        // Set the timer and show it immediately
        this.setCountdown(tenMinutes);
        this.showTimer();
        this.startTimer(tenMinutes);
    }
    
    cartCleared() {
        this.hideTimer();
        
        if (this.currentInterval) {
            clearInterval(this.currentInterval);
            this.currentInterval = null;
        }
        
        this.setWithExpiry('cartTimer', 0);
    }
}

customElements.define('cart-timer', CartTimer);

// Initialize the cart timer with the cart drawer
document.addEventListener('DOMContentLoaded', () => {
    const cartTimer = document.querySelector('cart-timer');
    if (!cartTimer) return;
    
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    
    // Optional: Start timer when drawer opens if it's not already running
    const observer = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
            if (
                mutation.type === 'attributes' &&
                mutation.attributeName === 'class' &&
                drawer.classList.contains('active')
            ) {
                // Check if timer is already running
                const currentValue = parseInt(cartTimer.getWithExpiry('cartTimer'));
                if (!currentValue || currentValue <= 0) {
                    cartTimer.productAddedToCart();
                }
            }
        }
    });
    
    observer.observe(drawer, { attributes: true });
});